export default __webpack_public_path__ + "static/media/no.97e8bacc.svg";